import { useEffect } from 'react';
import { useShallowAppSelector } from 'store/hooks';
import { BaseActions } from 'store/actionCreators';
import { isLogInSelector } from 'store/modules/auth';

export const scan_write_indication = 'writeIndication';
export const scan_start_build = 'startBuild';
export const scan_progress_build = 'progressBuild';
export const scan_finish_build = 'finishBuild';
export const scan_store_build = 'storeBuild';

function ScanProcessChecker() {
  const { isLogIn } = useShallowAppSelector(state => ({
    isLogIn: isLogInSelector(state),
  }));
  const { ipcRenderer } = window;

  useEffect(() => {
    if (!ipcRenderer) return;
    ipcRenderer.on(scan_write_indication, (e: any, data: any) => {
      //       {
      //   "projectId": "projectID-0000",
      //   "projectCode": "projectCode"
      // }
      BaseActions.scan_edit_project(data);

      // console.log('PMS] viewThumbnail _______ ', data);
      // handleCloseEditProjectAlert;
      // setEditProjectCode(data.projectCode);
    });
    ipcRenderer.on(scan_start_build, (e: any, data: any) => {
      //       {
      //   "projectId": "projectID-0000",
      //   "projectCode": "projectCode"
      // }
      console.log('PMS] viewThumbnail _______ ', data);
      BaseActions.scan_process({ command: scan_start_build, data: data });
    });
    ipcRenderer.on(scan_progress_build, (e: any, data: any) => {
      //       {
      //   "projectId": "projectID-0000",
      //   "projectCode": "projectCode",
      //   "progress": 10
      // }
      console.log('PMS] viewThumbnail _______ ', data);
      BaseActions.scan_process({ command: scan_progress_build, data: data });
    });
    ipcRenderer.on(scan_finish_build, (e: any, data: any) => {
      //       {
      //   "projectId": "projectID-0000",
      //   "projectCode": "projectCode"
      // }
      console.log('PMS] viewThumbnail _______ ', data);
      BaseActions.scan_process({ command: scan_finish_build, data: data });
    });
    ipcRenderer.on(scan_store_build, (e: any, data: any) => {
      //      {
      //   "projectId": "projectID-0000",
      //   "projectCode": "projectCode",
      //   "failFiles": [],
      //   "successFiles": [
      //     "C:\DOFSync\a-downcase.stl",
      //     "C:\DOFSync\a-uppercase.stl",
      //     "C:\DOFSync\a.png"
      //   ],
      //   "msg": {‘SUCCESS’ : 성공

      // ‘OUT_OF_STORAGE’ : 클라우드 공간 부족

      // ‘CANNOT_UPLOAD_PROJECT_FILE’ : 업로드 중 문제 또는 에러로 업로드 할 수 없음 }
      // }
      console.log('PMS] viewThumbnail _______ ', data);
      BaseActions.scan_process({ command: scan_store_build, data: data });
    });
  }, []);

  return null;
}

export const handleClearScanprocess = () => {
  console.log('PMS] handleClearPmsData _________ ');
  BaseActions.scan_process({
    command: null,
    data: null,
  });
};

export const handleClearScanEdit = () => {
  console.log('PMS] handleClearPmsData _________ ');
  BaseActions.scan_edit_project(null);
};

export default ScanProcessChecker;

export const testScanWriteIndication = () => {
  BaseActions.scan_edit_project({
    projectId: 'projectID-0000',
    projectCode: '4997e9671b066a688ad848aa5f00cd2d',
  });
};
export const testScanStart = () => {
  BaseActions.scan_process({
    command: scan_start_build,
    data: {
      projectId: 'projectID-0000',
      projectCode: '4997e9671b066a688ad848aa5f00cd2d',
    },
  });
};
export const testScanStartProcessing = () => {
  BaseActions.scan_process({
    command: scan_progress_build,
    data: {
      projectId: 'projectID-0000',
      projectCode: '4997e9671b066a688ad848aa5f00cd2d',
      progress: 80,
    },
  });
};
export const testScanProcess = () => {
  const processing = (count: number) =>
    BaseActions.scan_process({
      command: scan_progress_build,
      data: {
        projectId: 'projectID-0000',
        projectCode: '4997e9671b066a688ad848aa5f00cd2d',
        progress: count,
      },
    });

  let count = 0;
  const intervalProcessing = setInterval(() => {
    processing(count);
    count = count + 10;
    if (count > 100) {
      clearInterval(intervalProcessing);
      count = 0;
      BaseActions.scan_process({
        command: scan_finish_build,
        data: {
          projectId: 'projectID-0000',
          projectCode: '4997e9671b066a688ad848aa5f00cd2d',
        },
      });
    }
  }, 200);
};
export const testScanFinish = () => {
  BaseActions.scan_process({
    command: scan_finish_build,
    data: {
      projectId: 'projectID-0000',
      projectCode: '4997e9671b066a688ad848aa5f00cd2d',
    },
  });
};
export const testScanStore = () => {
  console.log('SCAN] testScanStore');
  BaseActions.scan_process({
    command: scan_store_build,
    data: {
      projectId: "20250205-0205스캔바디-0205스캔바디's 프로젝트-0000-7024012205a",
      projectCode: '4997e9671b066a688ad848aa5f00cd2d',
      msg: 'SUCCESS',
    },
  });
};

export const testScanStore2 = () => {
  console.log('SCAN] testScanStore2');
  BaseActions.scan_process({
    command: scan_store_build,
    data: {
      projectId: "20250205-장태석-장태석's 프로젝트-0003-7024012205a",
      projectCode: '4997e9671b066a688ad848aa5f00cd2d',
      msg: 'SUCCESS',
    },
  });
};
